import { call, put, takeEvery } from "redux-saga/effects";
import * as actions from "actions/login";
import { apiPost, apiGet, apiSetAuthToken } from "sagas/callApi";

function* login(api, { payload, meta }) {
  try {
    const { data } = payload;
    const resp = yield call(apiPost, api, `/login`, data, true);
    yield call(apiSetAuthToken, api, resp.data.api_token);
    localStorage.setItem("api_token", resp.data.api_token);
    yield put(actions.loginSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.loginFailed(e, meta));
  }
}

function* authenticate(api, { payload, meta }) {
  try {
    yield call(apiSetAuthToken, api, localStorage.getItem("api_token"));
    const resp = yield call(apiGet, api, `/user/me`);
    yield put(actions.authenticateSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.authenticateFailed(e, meta));
  }
}

function logout({ meta }) {
  localStorage.removeItem("api_token");
}

export default function* rootSaga({ api }) {
  yield takeEvery(actions.LOGIN, login, api);
  yield takeEvery(actions.LOGOUT, logout);
  yield takeEvery(actions.AUTHENTICATE, authenticate, api);
}



// WEBPACK FOOTER //
// ./src/sagas/login.js